import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule, CurrencyPipe, DecimalPipe, PercentPipe } from '@angular/common';
import { AppStorage } from 'app/utilities/storage';

@Component({
    selector: 'app-metric-card',
    imports: [CommonModule],
    template: `
    <div class="p-5 rounded-lg bg-white shadow-sm min-h-[140px] flex flex-col justify-between">
      <p class="sz-metric-label">{{ label }}</p>
      <div class="mt-3">
        <p class="sz-metric-value" [ngClass]="valueClass || 'text-gray-900'">
          {{ formattedValue }}
        </p>
        @if (trend !== undefined && trend !== null) {
          <div class="flex items-center gap-1 mt-1">
            <span [ngClass]="trend >= 0 ? 'text-green-600' : 'text-red-600'" class="text-xs font-medium">
              {{ trend >= 0 ? '\u25B2' : '\u25BC' }} {{ absTrend }}%
            </span>
            @if (subtitle) {
              <span class="text-xs text-gray-400">{{ subtitle }}</span>
            }
          </div>
        }
        @if (subtitle && (trend === undefined || trend === null)) {
          <p class="text-xs text-gray-400 mt-1">{{ subtitle }}</p>
        }
      </div>
    </div>
    `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MetricCardComponent {
  @Input() label = '';
  @Input() value: number | string = 0;
  @Input() subtitle?: string;
  @Input() valueClass?: string;
  @Input() trend?: number;
  @Input() format: 'number' | 'currency' | 'percentage' | 'hours' = 'number';

  private currencyPipe = new CurrencyPipe('en-GB');
  private decimalPipe = new DecimalPipe('en-GB');
  private percentPipe = new PercentPipe('en-GB');

  get formattedValue(): string {
    if (typeof this.value === 'string') return this.value;
    switch (this.format) {
      case 'currency':
        return this.currencyPipe.transform(this.value, AppStorage.getLocalStorageDataRaw('X-User-Currency') || 'USD', 'symbol', '1.2-2') ?? '0';
      case 'percentage':
        return this.percentPipe.transform(this.value / 100, '1.1-1') ?? '0%';
      case 'hours':
        return `${this.decimalPipe.transform(this.value, '1.1-1') ?? '0'}h`;
      default:
        return this.decimalPipe.transform(this.value, '1.0-0') ?? '0';
    }
  }

  get absTrend(): string {
    return Math.abs(this.trend ?? 0).toFixed(1);
  }
}
